<label id="{{id}}_label"
  for='{{id}}_input'
  [ngClass]="{'visually-hidden' : !label }">
  @if (label) {
    <span>
      {{ label | translate }}
      @if (required) {
        <a>*</a>
      }
    </span>
  } @else {
    Bitte geben Sie einen Wert an
  }
  @if (hinweis) {
    <wba-fragezeichen
      [label]="label"
      [dataTarget]="hinweis?.target"
      [dataModal]="hinweis?.modal"
      id="{{id}}_fragezeichen"
      smaller="true"/>
  }
</label>

<div class="input-group">
  <input id="{{id}}_input"
    #input
    [type]="inputType"
    class='form-control'
    [ngClass]="{'ba-error': isInvalid}"
    [name]='name'
    [attr.data-has-error]="isInvalid"
    [attr.data-error-message]="control?.errors?.message"
    [placeholder]='placeholder'
    [attr.aria-label]='ariaLabel'
    [attr.aria-invalid]="isInvalid"
    (blur)="onBlur()"
    [imask]="maskOptions"
    [(ngModel)]="value">
  @if (unitLabel !== '') {
    <span class="input-group-text">
      {{ unitLabel }}
    </span>
  }
</div>

@if (isInvalid) {
  <wba-error-message _id="{{id}}" [control]="control"/>
}

